const cpf = (value) => {
  if (!value) {
    return false;
  }
  return value.split('.').join('').split('-').join('').length === 11;
};

export default cpf;
